import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Input,
  Button,
  FormText
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import Form from '../../../shared/components/Form';
import HiddenInput from '../../../shared/components/HiddenInput';

import {
  ADJOY_DEFAULT_CHOOSE_COST,
  ADJOY_DEFAULT_THIS_OR_THAT_COST,
  ADJOY_DEFAULT_RATABLE_COST,
  ADJOY_DEFAULT_REVENUE_SPLIT
} from '../../../config';

import { checkUniquenessOfAgencyName } from '../utils';

const CREATE_NEW_AGENCY_OPTION = '__CREATE_NEW_AGENCY_OPTION__';

class CampaignAgencyForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      selectedValue:CREATE_NEW_AGENCY_OPTION,
      agencyExists:false
    };
  }

  componentDidMount(){
    if(this.props.activeAgencyId){
      this.setState({selectedValue:this.props.activeAgencyId});
    }
  }

  handleSubmit(data){
    console.log('GOT DATA',data);

    const validationMessages = {};

    if(!data.agencyId || data.agencyId === ''){
      validationMessages['agencyId'] = 'Agency is required';
    }

    if(data.agencyId === CREATE_NEW_AGENCY_OPTION){
      if(!data.agencyName || data.agencyName === ''){
        validationMessages['agencyName'] = 'Name is required';
      }

      if(this.state.agencyExists){
        validationMessages['agencyName'] = 'This name is already taken please choose another one';
      }
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  handleCheckIfAccountExists(name){
    const validationMessages = {};

    checkUniquenessOfAgencyName(name.trim())
      .then((res) => {
        if(!!res.id){
          validationMessages['agencyName'] = 'This name is already taken please choose another one';
          this.setState({validationMessages:validationMessages,agencyExists:true});
        } else {
          this.setState({validationMessages:{},agencyExists:false});
        }
      });
  }

  render(){
    const { validationMessages, selectedValue, agencyExists } = this.state;

    const { possibleAgencies } = this.props;

    const isCreatingAgency = this.state.selectedValue === CREATE_NEW_AGENCY_OPTION;

    return (
      <Form onSubmit={(data) => this.handleSubmit(data)}>
        <HiddenInput 
          name='defaultRevenueSplit' 
          value={ADJOY_DEFAULT_REVENUE_SPLIT} 
        />
        <HiddenInput 
          name='chooseDefaultCost' 
          value={ADJOY_DEFAULT_CHOOSE_COST} 
        />
        <HiddenInput 
          name='thisOrThatDefaultCost' 
          value={ADJOY_DEFAULT_THIS_OR_THAT_COST} 
        />
        <HiddenInput 
          name='ratableDefaultCost' 
          value={ADJOY_DEFAULT_RATABLE_COST} 
        />
        <FormGroup>
          <Input
            type='select'
            name='agencyId'
            value={selectedValue}
            onChange={(e) => this.setState({selectedValue:e.target.value})}
          >
            <option value={CREATE_NEW_AGENCY_OPTION}>Create a new Account</option>
            {possibleAgencies.map((a) => (
              <option key={a.id} value={a.id}>
                {a.name}
              </option>
            ))}
          </Input>
          {validationMessages['agencyId'] && (
            <FormText className='DangerFeedback'>
              {validationMessages['agencyId']}
            </FormText>
          )}
        </FormGroup>
        {isCreatingAgency && (
          <TextInput
            label='New account name'
            name='agencyName'
            placeholder='Acme Inc.'
            maxLength={80}
            debounce={500}
            onChange={(name) => this.handleCheckIfAccountExists(name)}
            warning={validationMessages['agencyName']}
          />
        )}
        <Button 
          size='sm' 
          color='primary' 
          disabled={agencyExists}
        >
          &nbsp;&nbsp;{isCreatingAgency ? 'Create Account and save':'Save'}&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignAgencyForm.propTypes = {
  onSubmit:PropTypes.func,
  possibleAgencies:PropTypes.arrayOf(PropTypes.shape({
    name:PropTypes.string.isRequired,
    id:PropTypes.string.isRequired
  }))
};

CampaignAgencyForm.defaultProps = {
  onSubmit:() => {},
  onAgencyCreateSubmit:() => {},
  onAgencyUpdateSubmit:() => {},
  possibleAgencies:[]
};

export default CampaignAgencyForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignAgencyForm.js